import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios"; import Cookies from "js-cookie";
import moment from "moment";
import {Tooltip} from "primereact/tooltip";

import HelpComponent from "../HelpComponent";

const _FM_EzeelogShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {accommodationId, id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    if (window.App.urlVars().logId) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "ezee-event-log/" + window.App.urlVars().logId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderEzeelogList])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || 'Ezee ' + t('log_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="unique_id">Unique id</label>
              <span className="p-d-block p-text-bold">
                {formData.unique_id}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="sub_booking_id">Sub booking id</label>
              <span className="p-d-block p-text-bold">
                {formData.sub_booking_id}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="event_type">Event type</label>
              <span className="p-d-block p-text-bold">
                {formData.event_type}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="event_type">{t('reservation')}</label>
              <span className="p-d-block p-text-bold">
                {/*<i className={"pi pi-window-maximize"}*/}
                {/*   onClick={(e) => {*/}
                {/*     navigate('/ezee/' + accommodationId + '/log/' + id + '?update=reservation&reservationId=' + formData.reservation?.id)*/}
                {/*   }}*/}
                {/*></i>*/}
                {/*&nbsp;*/}
                {formData?.reservation?.association_code &&
                  <>
                    <span className={"tt-association-code-ezee-show-info-" + formData?.reservation?.id + " p-mr-2"}
                          data-pr-tooltip={formData?.reservation?.association_code}>
                      <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                    </span>
                    <Tooltip target={".tt-association-code-ezee-show-info-" + formData?.reservation?.id}/>
                    <span className={"p-badge"}
                          style={{
                            fontSize: '1rem',
                            backgroundColor: formData?.reservation?.status
                              ? formData?.reservation?.status?.toLowerCase() === 'pending'
                                ? '#dddddd'
                                : formData?.reservation?.status?.toLowerCase() === 'confirmed'
                                  ? '#f1eea5'
                                  : formData?.reservation?.status?.toLowerCase() === 'cancelled'
                                    ? '#f7a2a2'
                                    : formData?.reservation?.status?.toLowerCase() === 'checked_in'
                                      ? '#3ec0e9'
                                      : formData?.reservation?.status?.toLowerCase() === 'checked_out'
                                        ? '#0abb87'
                                        : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                          ? '#8a2be2'
                                          : '#ccc'
                              : undefined,
                            color: formData?.reservation?.status
                              ? formData?.reservation?.status?.toLowerCase() === 'pending' || formData?.reservation?.status?.toLowerCase() === 'confirmed'
                                ? '#5f656b'
                                : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                  ? '#fff'
                                  : undefined
                              : undefined
                    }}>
                      {formData?.reservation?.association_code?.split(' | ').pop()?.trim()}
                    </span>
                  </>
                }
              </span>
            </div>
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_EzeelogShowComponent);
